import React from 'react';

import { Stack } from '@mui/material';

import type { LuxPlusPromoCardCarouselState } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/types';

import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../../FieldLabels';
import LoadPayloadSection from '../../LoadPayloadSection';

import PromoCardCarouselCardsSection from './PromoCardCarouselCardsSection';

interface PromoCardCarouselPayloadBuilderFormProps {
  collapseResetKey: number;
  state: LuxPlusPromoCardCarouselState;
  onChange: (next: LuxPlusPromoCardCarouselState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function PromoCardCarouselPayloadBuilderForm({
  collapseResetKey,
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: PromoCardCarouselPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Stack key={collapseResetKey} sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        <PromoCardCarouselCardsSection promos={state.promos} onChange={(promos) => onChange({ ...state, promos })} />
      </Stack>
    </Stack>
  );
}
